import Place, { Place_Source } from "./Place";
import { API_BASE_URL } from "../Common/Common";

export default class GoogleTranslate {
  // constructor() {
  // }

  //https://translation.googleapis.com/language/translate/v2?key=REDACTED&q=cheese&target=es
  // POST with the text in the JSON body, not a GET query param — a whole
  // itinerary/home-screen document's HTML is easily tens of KB, and
  // embedding that (URL-encoded, no less) in a GET URL blows past the
  // ~8-16k char limit browsers/CDNs/the API itself enforce on URL length.
  // That request then fails (400/414), is swallowed by the .catch below
  // into an empty callback([]) with no user-visible error, and
  // translateCallback's own try/catch silently no-ops — so "Home Screen"
  // (the largest single field this dialog translates) looked like it did
  // nothing. Event Body/place Info are small enough to fit a GET URL, so
  // those kept working, masking the real cause. Found 2026-09-17.
  static translate = (text, target, callback, obj, type, last) => {
    if (typeof text === "undefined" || text === null) return;
    var url = `https://translation.googleapis.com/language/translate/v2?key=${process.env.REACT_APP_GOOGLE_TRANSLATE_KEY}`;
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ q: text, target, format: "html" }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        //console.log("response", JSON.stringify(response));
        callback(response, obj, type, last);
      })

      .catch(function (error) {
        console.log("Error in Google translate", error);
        callback([]);
      });
  };
}
